import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@material-ui/icons/Close';
import DqtPurchasePanel from '../../../../components/DqtPurchasePanel.comp';
import { shortfallLine } from '../../../utils/credit_shortfall.utils';

/**
 * Top up from inside the program builder, for a workspace that does not buy credits
 * by card: a partner owner buys DQ Tokens; a direct school or network owner buys
 * credits for its organisation. Same checkout as Settings → Billing (the API decides
 * what is on sale and to whom), showing only the top-up, pre-filled with what the
 * build is short.
 *
 * `onPurchased` fires once a card payment is confirmed and fulfilled; a bank transfer
 * is added only after DQ approves it, so it does not resume the build.
 *
 * @param {object}   props
 * @param {boolean}  props.open
 * @param {Function} props.onClose
 * @param {object}   props.info            the shortfall card's data ({ payer, shortfall, dqt })
 * @param {object}   props.need            what to pre-fill: { dqt } or { credits }
 * @param {string}   props.publishableKey  Stripe key for the checkout
 * @param {Function} props.onPurchased
 */
const BuildTopUpDialog = ({ open, onClose, info, need, publishableKey, onPurchased }) => {
    const inDqt = info?.payer?.currency === 'dqt';
    const line = shortfallLine(info);
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
            <DialogTitle sx={{
                borderBottom: `2px solid ${inDqt ? '#0097b2' : '#FF6900'}`, pb: 2,
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            }}>
                <Box>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'var(--brand-text, #000)' }}>
                        {inDqt ? 'Top Up DQ Tokens' : 'Top Up Credits'}
                    </Typography>
                    {line && (
                        <Typography variant="body2" sx={{ color: 'var(--brand-text-muted, #64748b)', mt: 0.25 }}>
                            {line} Your program will continue once the payment is confirmed.
                        </Typography>
                    )}
                </Box>
                <IconButton onClick={onClose} size="small" aria-label="Close">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 1, pb: 3 }}>
                {open && (
                    <DqtPurchasePanel
                        topUpOnly
                        need={need}
                        publishableKey={publishableKey}
                        onPurchased={onPurchased}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default BuildTopUpDialog;
